import React, { Component } from 'react';
import { DatePicker, Button, Radio, Input, message, Modal, Popconfirm, Select, Pagination, ConfigProvider } from 'antd';
import Loading from '../../components/loading/loading';
import DocumentTitle from 'react-document-title';
import API from '../../../api/api';
import moment from 'moment';
import UEditor from "../../components/ueditor/ueditor";
import ColorPicker from '../../components/colorPicker/colorPicker';
import zhCN from 'antd/es/locale/zh_CN';
import './publishRules.less';
import PrizePreview from '../prizePreview/prizePreview';
const { Option } = Select;
const { confirm } = Modal;
var uploader = require('../../../thirdTool/alioss/upload.js');

class PublishActivity extends Component {
    constructor(props) {
        super(props)
    }
    state = {
        hbNum: '',//红包总个数
        defaultWinnum: '',//内定总个数
        remainPrize: 0,//剩余奖品数
        remainPrizeShow: '',//剩余奖品数显示
        remainDefault: 0,//剩余内定数
        remainDefaultShow: '',//剩余内定数显示
        remainRandom: 0,//剩余可分配数
        activityId: '',//活动Id
        yidunHongbao: "0",//蚁盾高分用户
        emptyWinUser: '',//内定用户内没有填写的项
        emptyRandom: '',//中奖用户没有填写的项
        showList: [],
        ruleType: 0,
        hasClickedSavePrize: false,//已经点击过添加奖品
        prizeLevelList: [
            { id: '1', type: '特等奖' },
            { id: '2', type: '一等奖' },
            { id: '3', type: '二等奖' },
            { id: '4', type: '三等奖' },
            { id: '5', type: '幸运奖' },
            { id: '6', type: '四等奖' },
            { id: '7', type: '五等奖' },
            { id: '8', type: '六等奖' },
            { id: '9', type: '七等奖' },
            { id: '10', type: '八等奖' },
            { id: '11', type: '九等奖' },
            { id: '12', type: '十等奖' },
            { id: '100', type: '未来之星奖' },
        ],
        hbList: [],
        winUsersMap: new Map(),
        RandomMap: new Map(),
        winNosList: Array(),
        newPrizeItem: {
            activityId: '',//'活动id'
            level: '1',//'奖项级别1：特等奖2：一等奖3：二等奖4：三等奖5: 幸运奖',6 四等，7五等，8六等，9七等，10八等，11 九等，12 十等奖，100补空奖
            hbType: '0',//'0:现金 1:实物', 
            hbName: '特等奖',//'奖项名称',
            totalAmount: '',//'总金额，单位为分',
            winAmount: '',//'领取总额，幸运奖才需要',
            hbNum: '',//'个数',
            winNum: '',//'领取个数,只有幸运奖需要更新',
            materialName: '',//'实物名称，奖项如果是实物，必填',
            materialImage: '',//{ "width": "958", "picture": "http://s1.im-dangdang.com/20180130/1517318458565572.jpg", "height": "1280" },//'实物图片，如果是实物奖项，选填，现金奖励不填',   {"width":"958","picture":"http://s1.im-dangdang.com/20180130/1517318458565572.jpg","height":"1280"}
            mode: 1,//'发放模式 1:随机 2：指定或平均',
            winNos: [],//'中奖序号，例如：[2,3,5]',
            luckyMin: '',//'幸运奖金额随机下限',
            luckyMax: '',//'幸运奖金额随机上限',
            defaultNum: '',//'内定中奖个数',
            subType: 0,//'对实物奖来说 0：普通实物 1：红包卡奖项',2:奖券,
            hbCardNum: '',//'对红包卡实物来说，每个包的红包卡数量',
            winUsers: [],//'内定中奖用户id，例如[10012,10014]',
            subRelation_id: '',//'实物关联ID',
            singleMoney: '',
            luckNumType: 1,//非内定奖项的发放方式   1:指定 2：随机',
            futureCashMode: 1,//未来之星奖现金奖的分发方式 1 : 随机 2 :固定,
            specialLuckyList: [],
        },
        checkPrizeList: '',
        modalShow: false
    }

    componentDidMount() {
        this.setState({
            activityId: this.getQueryString('activityId'),
            ruleType: this.getQueryString('ruleType'),
        }, () => {
            console.log('activityId:', this.getQueryString('activityId'))
            if (this.state.ruleType == 1) {
                this.getRuleDetail();
            }
        })
    }

    async getPictureInfo(url) { // 获取图片信息
        let result = await API.syncPic({ url: url });
        if (!result) return;
        if (result) {
            let picObj = {
                picture: url,
                width: result.ImageWidth.value,
                height: result.ImageHeight.value
            }
            return picObj;
        }
        else {
            message.error(result.msg);
        }
    };
    async getVideoInfo(url) { // 获取视频信息
        let result = await API.syncVideo({ videoUrl: url });
        if (!result) return;
        if (result.status == 1) {
            let picObj = {
                videoUrl: url,
                pictureUrl: result.data.pictureUrl,
                width: result.data.width,
                height: result.data.height,
                duration: result.data.duration
            };
            return picObj;
        }
        else {
            message.error(result.msg);
        }
    };
    async publishRule(params) { // 发布规则
        let result = await API.publishRules(params);
        if (!result) return;
        if (result.status == 1) {
            message.success('发布成功')
            // window.location.href = '/console/jsps/ttleActivity/newTtleActivityList2.jsp?pagecurr=1'
        }
        else {
            message.error(result.msg);
        }
    };
    componentWillReceiveProps(nextProps) {
        // this.setState({
        //     activityId: this.getQueryString('activityId'),
        //     ruleType: this.getQueryString('ruleType'),
        // }, () => {
        //     console.log('activityId:',this.getQueryString('activityId'))
        //     if (this.state.ruleType == 1) {
        //         this.getRuleDetail();
        //     }
        // })
    }
    async getRuleDetail() {
        const { activityId } = this.state;
        let result = await API.getActivityDetail({ activityId: activityId });
        if (result.status == 1) {
            let hbList = result.data.hbList;
            let ttLeActivity = result.data.ttLeActivity;
            hbList.map((item, index) => {
                //数组格式化
                if (item.winNos)
                    item.winNos = JSON.parse(item.winNos)
                if (item.winUsers)
                    item.winUsers = JSON.parse(item.winUsers)
                //
                if (item.totalAmount)
                    item.singleMoney = Number(item.totalAmount) / Number(item.hbNum) / 100;
                if (item.materialImage)
                    item.materialImage = JSON.parse(item.materialImage)
                if (item.luckyMax && item.luckyMin)
                    item.futureCashMode = item.luckyMax == item.luckyMin ? 2 : 1
            })

            this.setState({
                hbList,
                hbNum: ttLeActivity.hbNum,
                defaultWinnum: ttLeActivity.defaultWinnum,
                yidunHongbao: ttLeActivity.yidunHongbao
            })
        } else {
            message.error(result.msg)
        }
    }
    getQueryString(name) {//解析url
        const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        const urlObj = window.location;
        var r = urlObj.href.indexOf('#') > -1 ? urlObj.hash.split("?")[1].match(reg) : urlObj.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    }
    addNewPrize() {
        const { newPrizeItem, hbList, showList, activityId, hbNum, remainDefault, remainPrize, remainRandom, winNosList, defaultWinnum } = this.state;
        this.setState({ hasClickedSavePrize: true }, () => {
            for (let i = 0; i < newPrizeItem.winUsers.length; i++) {
                if (newPrizeItem.winUsers[i] == '') {
                    this.setState({ emptyWinUser: i + 1 })
                    break;
                }
            }
            newPrizeItem.activityId = activityId;
            if (document.querySelector('.addPrizePane').querySelectorAll('.formItemError').length > 0) {
                return;
            }
            if (newPrizeItem.level != 100 && newPrizeItem.luckNumType == 1 && remainRandom > 0) {
                message.error('该奖项奖品数量未分发完')
                return;
            }
            if (newPrizeItem.luckNumType == 1) {//指定序号
                newPrizeItem.winNos = [];
                winNosList.map((item) => {
                    newPrizeItem.winNos = newPrizeItem.winNos.concat(item)
                })
            }
            newPrizeItem.totalAmount *= 100;
            newPrizeItem.winAmount *= 100;
            showList.push(false);
            this.setState({
                hbList: hbList.concat(newPrizeItem), showList,
                remainPrize: remainPrize - newPrizeItem.hbNum,
                remainDefault: remainDefault - newPrizeItem.defaultNum,
                hasClickedSavePrize: false
            }, () => {
                this.initNewPrizeItem();
            })
        })

    }
    initNewPrizeItem() {//初始化新奖品
        this.setState({
            newPrizeItem: {
                activityId: '',//'活动id'
                level: '1',//'奖项级别1：特等奖2：一等奖3：二等奖4：三等奖5: 幸运奖',6 四等，7五等，8六等，9七等，10八等，11 九等，12 十等奖，100补空奖
                hbType: '0',//'0:现金 1:实物', 
                hbName: '特等奖',//'奖项名称',
                totalAmount: '',//'总金额，单位为分',
                winAmount: '',//'领取总额，幸运奖才需要',
                hbNum: '',//'个数',
                winNum: '',//'领取个数,只有幸运奖需要更新',
                materialName: '',//'实物名称，奖项如果是实物，必填',
                materialImage: '',//{ "width": "958", "picture": "http://s1.im-dangdang.com/20180130/1517318458565572.jpg", "height": "1280" },//'实物图片，如果是实物奖项，选填，现金奖励不填',   {"width":"958","picture":"http://s1.im-dangdang.com/20180130/1517318458565572.jpg","height":"1280"}
                mode: 1,//'发放模式 1:随机 2：指定或平均',
                winNos: [],//'中奖序号，例如：[2,3,5]',
                luckyMin: '',//'幸运奖金额随机下限',
                luckyMax: '',//'幸运奖金额随机上限',
                defaultNum: '',//'内定中奖个数',
                subType: 0,//'对实物奖来说 0：普通实物 1：红包卡奖项',2:奖券,
                hbCardNum: '',//'对红包卡实物来说，每个包的红包卡数量',
                winUsers: [],//'内定中奖用户id，例如[10012,10014]',
                subRelation_id: '',//'实物关联ID',
                singleMoney: '',
                luckNumType: 1,//非内定奖项的发放方式   1:指定 2：随机',
                futureCashMode: 1,//未来之星奖现金奖的分发方式 1 : 随机 2 :固定,
                specialLuckyList: [],
            }
        })
    }
    addSpecialLuckyList() {
        const { newPrizeItem } = this.state;
        let obj = {
            num: '',
            min: '',
            max: '',
            winNos: []
        }
        let count = 0;
        newPrizeItem.specialLuckyList.map((item, index) => {
            count += Number(item.num);
        })
        let remainRandom = Number(newPrizeItem.hbNum) - Number(newPrizeItem.defaultNum) - count;
        newPrizeItem.specialLuckyList.push(obj);
        this.setState({ newPrizeItem, remainRandom })
    }
    storeValue(type, e) {
        let value = e.target.value;
        switch (type) {
            case 'hbNum':
                this.setState({
                    hbNumStore: value
                })
                break;
            case 'defaultWinnum':
                this.setState({
                    defaultWinnumStore: value
                })
                break;
        }
    }
    blurZeroToNull(type, e) {//失去焦点后
        let value = e.target.value;
        const {
            newPrizeItem,
            hbNumStore,
            defaultWinnumStore,
            hbList,
            hbNum
        } = this.state;
        let self = this;
        function initParam() {//清空奖品初始化的值
            self.setState({
                hbList: [],//重置奖品列表
                RandomMap: new Map,//重置随机数记录数组
                remainRandom: 0,//剩余可分配数
                emptyWinUser: '',//内定用户内没有填写的项
                emptyRandom: '',//中奖用户没有填写的项
                showList: [],
                hasClickedSavePrize: false,//已经点击过添加奖品
                winUsersMap: new Map(),
                RandomMap: new Map(),
                winNosList: Array(),
                newPrizeItem: {
                    activityId: '',//'活动id'
                    level: '1',//'奖项级别1：特等奖2：一等奖3：二等奖4：三等奖5: 幸运奖',6 四等，7五等，8六等，9七等，10八等，11 九等，12 十等奖，100补空奖
                    hbType: '0',//'0:现金 1:实物', 
                    hbName: '特等奖',//'奖项名称',
                    totalAmount: '',//'总金额，单位为分',
                    winAmount: '',//'领取总额，幸运奖才需要',
                    hbNum: '',//'个数',
                    winNum: '',//'领取个数,只有幸运奖需要更新',
                    materialName: '',//'实物名称，奖项如果是实物，必填',
                    materialImage: '',//{ "width": "958", "picture": "http://s1.im-dangdang.com/20180130/1517318458565572.jpg", "height": "1280" },//'实物图片，如果是实物奖项，选填，现金奖励不填',   {"width":"958","picture":"http://s1.im-dangdang.com/20180130/1517318458565572.jpg","height":"1280"}
                    mode: 1,//'发放模式 1:随机 2：指定或平均',
                    winNos: [],//'中奖序号，例如：[2,3,5]',
                    luckyMin: '',//'幸运奖金额随机下限',
                    luckyMax: '',//'幸运奖金额随机上限',
                    defaultNum: '',//'内定中奖个数',
                    subType: 0,//'对实物奖来说 0：普通实物 1：红包卡奖项',2:奖券,
                    hbCardNum: '',//'对红包卡实物来说，每个包的红包卡数量',
                    winUsers: [],//'内定中奖用户id，例如[10012,10014]',
                    subRelation_id: '',//'实物关联ID',
                    singleMoney: '',
                    luckNumType: 1,//非内定奖项的发放方式   1:指定 2：随机',
                    futureCashMode: 1,//未来之星奖现金奖的分发方式 1 : 随机 2 :固定,
                    specialLuckyList: [],
                },
            })
        }
        switch (type) {
            case 'hbNum':
                if (this.hbListAmount(hbList, 'hbNum') > Number(value)) {
                    this.showConfirm('已分配的奖品多于设置的红包总个数，更改后将会清空已分配的奖品', function () {
                        self.setState({
                            hbNum: value,//重置红包数
                            remainPrize: value//重置剩余奖品
                        })
                        initParam();
                    }, function () {
                        self.setState({
                            hbNum: hbNumStore,
                            remainPrize: hbNumStore - self.hbListAmount(hbList, 'hbNum')
                        })
                    })
                }
                break;
            case 'defaultNum':
                if (Number(value) > Number(hbNum)) {
                    message.error('内定总个数不得大于红包总个数')
                    this.setState({
                        defaultWinnum: '',
                    })
                }
                if (this.hbListAmount(hbList, 'defaultNum') > Number(value)) {
                    this.showConfirm('已分配的内定奖品多余设置的内定总个数，更改后将会清空已分配的奖品', function () {
                        self.setState({
                            defaultWinnum: value,//重置红包数
                            remainDefault: value//重置剩余内定数
                        })
                        initParam();
                    }, function () {
                        self.setState({
                            defaultWinnum: defaultWinnumStore,
                            remainDefault: defaultWinnumStore - self.hbListAmount(hbList, 'defaultNum')
                        })
                    })
                }
                break;
        }
        this.setState({
            newPrizeItem
        })
    }
    initUpload() {
        let self = this;
        setTimeout(() => {
            let buttonList = [
                {
                    buttonID: 'chooseRealItemImage',
                    picType: 'realItemImage',
                    extensions: 'jpg,png,bmp,jpeg',
                },
            ]
            buttonList.map((item, index) => {
                if (document.getElementById(item.buttonID)) {
                    uploader({
                        serverUrl: window.location.origin + '/promotion/oss/policy',
                        upload_button: item.buttonID,
                        multi: false,
                        extensions: item.extensions,
                        added: function () {
                        },
                        success: function (file_url, file) {
                            let picObj;
                            if (file.type == 'video/mp4') {
                                self.getVideoInfo(file_url).then(obj => {
                                    const { newPrizeItem } = self.state;
                                    if (item.picType == 'realItemImage') {
                                        newPrizeItem.materialImage = obj;
                                        self.setState({
                                            newPrizeItem
                                        })
                                    }
                                    document.getElementById(item.buttonID).style.backgroundImage = 'url(' + obj.pictureUrl + ')';
                                })
                            } else {
                                self.getPictureInfo(file_url).then(obj => {
                                    const { newPrizeItem } = self.state;
                                    if (item.picType == 'realItemImage') {
                                        newPrizeItem.materialImage = obj;
                                        self.setState({
                                            newPrizeItem
                                        })
                                    }
                                    document.getElementById(item.buttonID).style.backgroundImage = 'url(' + obj.picture + ')';
                                });
                            }
                        },
                        error: function (msg) {
                            message.error(msg)
                        }
                    })
                }
            })
        }, 100)
    }
    hbListAmount(arr, type) {
        let count = 0;
        arr.map((item, index) => {
            if (type == 'hbNum')
                count += Number(item.hbNum);
            else if (type == 'defaultNum')
                count += Number(item.defaultNum);
        })
        return count;
    }
    showConfirm(text, fnSuccess, fnFailed) {
        confirm({
            title: '提示',
            content: text,
            onOk() {
                return new Promise((resolve, reject) => {
                    fnSuccess();
                    resolve();
                }).catch(() => console.log('Oops errors!'));
            },
            onCancel() { fnFailed(); },
        });
    }
    inputItemChange(type, e) {
        let value = e.target.value;
        const {
            newPrizeItem,
            hbList
        } = this.state;
        let newValStr = value + '';
        let reg = /^\d{1,10}(\.){0,1}(\d{1,2})?$/;
        switch (type) {
            case 'hbNum':
                const { hbNum } = this.state;
                if (value.trim() != '' && !/^[0-9]+$/.test(value)) {
                    value = hbNum;
                }
                this.setState({ hbNum: value == 0 ? '' : value, remainPrize: value.trim() == '' ? 0 : value - this.hbListAmount(hbList, 'hbNum') })
                break;
            case 'defaultNum':
                const { defaultWinnum } = this.state;
                if (value.trim() != '' && !/^[0-9]+$/.test(value))
                    value = defaultWinnum;

                this.setState({ defaultWinnum: value == 0 ? '' : value, remainDefault: value.trim() == '' ? 0 : value - this.hbListAmount(hbList, 'defaultNum') })
                break;
            case 'prizeName':
                newPrizeItem.hbName = value;

                break;
            case 'materialName':
                newPrizeItem.materialName = value;
                break;
            case 'singleMoney':

                if ((newValStr && !reg.test(newValStr)) || (newValStr.split('.').length > 2) || (newValStr.split('.')[1] && newValStr.split('.')[1].length > 2))
                    value = newPrizeItem.singleMoney;
                newPrizeItem.singleMoney = value;
                if (newPrizeItem.hbNum) {
                    newPrizeItem.totalAmount = value * newPrizeItem.hbNum;
                }
                break;
            case 'totalMoney':
                if ((newValStr && !reg.test(newValStr)) || (newValStr.split('.').length > 2) || (newValStr.split('.')[1] && newValStr.split('.')[1].length > 2))
                    value = newPrizeItem.totalAmount;
                newPrizeItem.totalAmount = value;
                break;
            case 'hbCardNum':
                if (value.trim() != '' && !/^[0-9]+$/.test(value))
                    value = newPrizeItem.hbCardNum;
                newPrizeItem.hbCardNum = value == 0 ? '' : value;
                break;
            case 'subRelation_id':
                if (value.trim() != '' && !/^[0-9]+$/.test(value))
                    value = newPrizeItem.subRelation_id;
                newPrizeItem.subRelation_id = value;
                break;
            case 'prizeHbNum':
                if (value.trim() != '' && !/^[0-9]+$/.test(value))
                    value = newPrizeItem.hbNum;
                newPrizeItem.hbNum = value == 0 ? '' : value;
                newPrizeItem.specialLuckyList = [];
                if (newPrizeItem.singleMoney) {
                    newPrizeItem.totalAmount = value * newPrizeItem.singleMoney;
                }
                break;
            case 'prizeDefaultNum':
                if (value.trim() != '' && !/^[0-9]+$/.test(value))
                    value = newPrizeItem.defaultNum;
                newPrizeItem.defaultNum = value == 0 ? '' : value;
                break;
            case 'luckyMin':
                if ((newValStr && !reg.test(newValStr)) || (newValStr.split('.').length > 2) || (newValStr.split('.')[1] && newValStr.split('.')[1].length > 2))
                    value = newPrizeItem.luckyMin;
                newPrizeItem.luckyMin = value * 100;
                break;
            case 'luckyMax':
                if ((newValStr && !reg.test(newValStr)) || (newValStr.split('.').length > 2) || (newValStr.split('.')[1] && newValStr.split('.')[1].length > 2))
                    value = newPrizeItem.luckyMax;
                newPrizeItem.luckyMax = value * 100;
                break;
            case 'luckyAll':
                if ((newValStr && !reg.test(newValStr)) || (newValStr.split('.').length > 2) || (newValStr.split('.')[1] && newValStr.split('.')[1].length > 2))
                    value = newPrizeItem.luckyMin | 0;
                newPrizeItem.luckyMin = value * 100;
                newPrizeItem.luckyMax = value * 100;
                break;

        }
        this.setState({
            newPrizeItem
        })
    }
    yidunHongbaoChange(value) {
        this.setState({
            yidunHongbao: value,
        });
    }
    radioChange(type, e) {
        let value = e.target.value;
        const {
            newPrizeItem
        } = this.state;
        switch (type) {
            case 'realPrizeType':
                newPrizeItem.subType = value;
                break;
            case 'luckyType':
                newPrizeItem.mode = value;
                break;
            case 'futureCashMode':
                newPrizeItem.futureCashMode = value;
                newPrizeItem.luckyMax = newPrizeItem.luckyMin = '';
                break;
        }
        this.setState({
            newPrizeItem,
            hasClickedSavePrize: false
        }, () => {

        })
    }
    getRandomNum(min, max, num) {//获取随机数 min 最小范围 max 最大范围 num 数量 
        const { RandomMap } = this.state;
        let nowResult = [];
        let luckyNum;
        max = parseInt(max);
        min = parseInt(min);
        while (num) {
            luckyNum = parseInt(min) + parseInt(Math.floor(Math.random() * (max + 1 - min)));
            if (nowResult.indexOf(luckyNum) == -1 && !RandomMap.get(luckyNum)) {
                nowResult.push(luckyNum);
                num--;
            }
            continue;
        }
        return nowResult;
    }
    sortArr(arr) {
        function compare(a, b) {
            return a - b;
        }
        arr.sort(compare);
        return arr;
    }
    randomWin(e) {
        let { hbNum, newPrizeItem, RandomMap, winNosList, remainRandom, defaultWinnum } = this.state;
        if (newPrizeItem.luckNumType != 1 || parseInt(e.target.value) != 1) {
            newPrizeItem.winNos.map((item => {
                RandomMap.set(Number(item), false)
            }))
            winNosList.map((item) => {
                item.map((value) => {
                    RandomMap.set(Number(value), false)
                })
            })
            newPrizeItem.winNos = [];
            winNosList = [];
            newPrizeItem.specialLuckyList = [];
            remainRandom = newPrizeItem.hbNum - newPrizeItem.defaultNum
        }
        newPrizeItem.luckNumType = parseInt(e.target.value);
        if (!newPrizeItem.hbNum || !hbNum) {
            this.setState({
                newPrizeItem
            })
            return;
        }

        if (!newPrizeItem.defaultNum)
            newPrizeItem.defaultNum = 0;
        if (e.target.value == 2) {
            let result = this.getRandomNum(1, hbNum - defaultWinnum, newPrizeItem.hbNum - newPrizeItem.defaultNum);
            result = this.sortArr(result);
            newPrizeItem.winNos = result;
            newPrizeItem.winNos.map((item, index) => {
                RandomMap.set(item, true)
            })
        }
        this.setState({
            newPrizeItem,
            RandomMap,
            remainRandom,
            winNosList
        })
    }
    selectChange(type, value) {
        const {
            newPrizeItem,
            prizeLevelList,
            RandomMap,
            winNosList
        } = this.state;
        let flag = false
        if (type == 'prizeType' || (type == 'prizeLevel' && newPrizeItem.level == 100)) {
            flag = true;
        }
        switch (type) {
            case 'prizeType':
                newPrizeItem.hbType = value;
                break;
            case 'prizeLevel':
                newPrizeItem.winNos.map((item => {
                    RandomMap.set(Number(item), false)
                }))
                winNosList.map((item) => {
                    item.map((value) => {
                        RandomMap.set(Number(value), false)
                    })
                })
                let obj = {
                    totalAmount: '',//'总金额，单位为分',
                    winAmount: '',//'领取总额，幸运奖才需要',
                    hbNum: '',//'个数',
                    winNum: '',//'领取个数,只有幸运奖需要更新',
                    materialName: '',//'实物名称，奖项如果是实物，必填',
                    materialImage: '',//{ "width": "958", "picture": "http://s1.im-dangdang.com/20180130/1517318458565572.jpg", "height": "1280" },//'实物图片，如果是实物奖项，选填，现金奖励不填',   {"width":"958","picture":"http://s1.im-dangdang.com/20180130/1517318458565572.jpg","height":"1280"}
                    mode: 1,//'发放模式 1:随机 2：指定或平均',
                    winNos: [],//'中奖序号，例如：[2,3,5]',
                    luckyMin: '',//'幸运奖金额随机下限',
                    luckyMax: '',//'幸运奖金额随机上限',
                    defaultNum: '',//'内定中奖个数',
                    subType: 0,//'对实物奖来说 0：普通实物 1：红包卡奖项',2:奖券,
                    hbCardNum: '',//'对红包卡实物来说，每个包的红包卡数量',
                    winUsers: [],//'内定中奖用户id，例如[10012,10014]',
                    subRelation_id: '',//'实物关联ID',
                    singleMoney: '',
                    luckNumType: 1,//非内定奖项的发放方式   1:指定 2：随机',
                    futureCashMode: 1,//未来之星奖现金奖的分发方式 1 : 随机 2 :固定,
                    specialLuckyList: [],
                }
                for (let key in obj) {
                    newPrizeItem[key] = obj[key]
                }
                newPrizeItem.level = value;
                prizeLevelList.map((item, index) => {
                    if (item.id == newPrizeItem.level)
                        newPrizeItem.hbName = item.type;
                })
        }

        this.setState({
            newPrizeItem,
            RandomMap,
            winNosList: [],
            hasClickedSavePrize: false
        }, () => {
            if (flag)
                this.initUpload()
        })
    }
    publishRules() {
        const { hbList, activityId, yidunHongbao, hbNum, defaultWinnum } = this.state;
        let data = {
            activityId: activityId,
            hbList: JSON.stringify(hbList),
            yidunHongbao: yidunHongbao,
            hbNum: hbNum,
            defaultWinnum: defaultWinnum
        }
        if (this.hbListAmount(hbList, 'defaultNum') < Number(defaultWinnum)) {
            message.error('内定数未分发完')
            return;
        }
        let hasFuture = false;// 是否有补空奖项
        let hasLuckCash = false;//是否有幸运现金奖
        let hasLuckReal = false;//是否有幸运实物奖
        let checkPrizeList = [];
        let allAmount = {
            'prizeName': '总计',
            'realPrizeNum': 0,
            'cashPrizeNum': 0,
            'defaultRealPrizeNum': 0,
            'defaultCashPrizeNum': 0,
            'singleMoney': '',
            'totalMoney': 0,
        }
        hbList.map((item, index) => {
            if (item.level == 100)
                hasFuture = true;
            if (item.level == 5 && item.hbType == 0)
                hasLuckCash = true;
            if (item.level == 5 && item.hbType == 1)
                hasLuckReal = true;
            if (item.level != 100) {
                let obj = {
                    'id': 'obj' + index,
                    'prizeName': item.hbName,
                    'realPrizeNum': item.hbType == 1 ? item.hbNum : 0,
                    'cashPrizeNum': item.hbType == 0 ? item.hbNum : 0,
                    'defaultRealPrizeNum': item.hbType == 1 ? item.defaultNum : 0,
                    'defaultCashPrizeNum': item.hbType == 0 ? item.defaultNum : 0,
                    'singleMoney': (item.hbType == 0 && item.singleMoney) ? item.singleMoney : 0,
                    'totalMoney': (item.hbType == 0 && item.totalAmount) ? item.totalAmount / 100 : 0,
                }
                for (let key in obj) {
                    if (key == 'realPrizeNum' || key == 'cashPrizeNum' || key == 'defaultRealPrizeNum' || key == 'defaultCashPrizeNum' || key == 'totalMoney')
                        allAmount[key] += Number(obj[key])
                }
                checkPrizeList.push(obj)
            }
        })
        allAmount.id = 'objAll';
        checkPrizeList.push(allAmount)
        if (!hasFuture) {
            message.error('未设置补空奖项');
            return;
        }
        // if(this.hbListAmount(hbList,'hbNum')<hbNum){
        //     message.error('红包未分发完')
        //     return;
        // }
        if ((yidunHongbao == 1 && !hasLuckCash) || (yidunHongbao == 2 && !hasLuckReal)) {
            message.error('蚁盾高分用户对应奖项为空');
            return;
        }
        this.setState({ checkPrizeList, modalShow: true }, () => {
            const { modalShow } = this.state
            console.log(modalShow)
        })
    }
    inputSpecialLuckyNum(type, index, e) {
        if (!e.target.value)
            return;
        let value = Number(e.target.value);
        const { newPrizeItem, remainRandom, hbNum, defaultWinnum } = this.state;
        switch (type) {
            case 'specialLuckyNum':
                if (Number(value) > Number(remainRandom)) {
                    message.error('不得多于剩余奖品数')
                    e.target.value = newPrizeItem.specialLuckyList[index].num;
                    return;
                } else {
                    newPrizeItem.specialLuckyList[index].num = value;
                    let count = 0;
                    newPrizeItem.specialLuckyList.map((item, index) => {
                        count += Number(item.num);
                    })
                    this.setState({
                        remainRandom: Number(newPrizeItem.hbNum) - Number(newPrizeItem.defaultNum) - count
                    })
                }
                break;
            case 'specialLuckyRangeMin':
                newPrizeItem.specialLuckyList[index].min = value;
                break;
            case 'specialLuckyRangeMax':
                if (Number(value) > Number(hbNum) - Number(defaultWinnum)) {
                    message.error('不可超出奖品序号范围')
                    e.target.value = newPrizeItem.specialLuckyList[index].max;
                } else {
                    newPrizeItem.specialLuckyList[index].max = value;
                }
                break;
        }
        this.setState({
            newPrizeItem
        })
    }
    changeSpecialLuckyNum(type, index, e) {
        let value = e.target.value;
        if (value == 0) {
            e.target.value = '';
            return;
        }
        if (value.trim() != '' && !/^[0-9]+$/.test(value)) {
            e.target.value = value.slice(0, value.length - 1)
        }
    }
    specialLuckyListClick(type, index, e) {
        let { newPrizeItem, hbNum, winNosList, RandomMap, remainRandom, defaultWinnum } = this.state;
        switch (type) {
            case 'random':
                let min = newPrizeItem.specialLuckyList[index].min;
                let num = newPrizeItem.specialLuckyList[index].num;
                let max = newPrizeItem.specialLuckyList[index].max;
                if (!hbNum) {
                    message.error('请先填写红包总个数')
                    return;
                }
                if (!newPrizeItem.defaultNum && newPrizeItem.level != 5) {
                    message.error('请先填写内定数量')
                    return;
                }
                if (Number(num) > Number(hbNum) - Number(defaultWinnum)) {
                    message.error('不可超出奖品序号范围');
                    return;
                }
                if (!min) {
                    min = 1;
                }

                if (!max) {
                    max = Number(hbNum) - Number(defaultWinnum);
                }
                let allMount = Number(max - min + 1);
                for (let item of RandomMap.keys()) {
                    console.log(item)
                    if (RandomMap.get(item) && item >= min && item <= max) {
                        allMount--;
                    }
                }
                if (allMount < Number(num)) {
                    message.error('该范围内数量不足以分配')
                    return;
                }

                //禁用本次随机
                e.target.disabled = true;
                let arr = this.getRandomNum(min, max, num);
                arr.map((item, index) => {
                    RandomMap.set(item, true);
                })
                winNosList[index] = arr;
                break;
            case 'delete':
                if (newPrizeItem.specialLuckyList[index].num) {
                    remainRandom += newPrizeItem.specialLuckyList[index].num;
                }
                newPrizeItem.specialLuckyList.splice(index, 1)
                if (winNosList[index]) {
                    winNosList[index].map((item) => {
                        RandomMap.set(item, false);
                    })
                    winNosList.splice(index, 1);
                }
                newPrizeItem.specialLuckyList.map((item, index) => {
                    document.getElementById('specialLuckNum' + index).value = item.num;
                    document.getElementById('specialLuckMin' + index).value = item.min;
                    document.getElementById('specialLuckMax' + index).value = item.max;
                })
                break;
        }
        this.setState({
            newPrizeItem, RandomMap, winNosList, remainRandom
        })
    }
    //输入内定用户的相关事件
    inputDefaultNumChange(index, e) {
        let value = e.target.value;
        const { emptyWinUser } = this.state;
        if (value.trim() != '' && !/^[0-9]+$/.test(value)) {
            e.target.value = value.slice(0, value.length - 1)
        }
        if (index == emptyWinUser - 1)
            this.setState({ emptyWinUser: '' })
    }
    inputDefaultNumBlur(index, e) {
        const { newPrizeItem, winUsersMap } = this.state;
        let value = e.target.value;
        if (winUsersMap.get(value)) {
            message.error('该内定用户ID已经存在');
            e.target.value = '';
            return;
        }
        newPrizeItem.winUsers[index] = value;
        winUsersMap.set(value, true);
        this.setState({
            newPrizeItem,
            winUsersMap
        })
    }
    focusDefaultNum(e) {
        const { winUsersMap } = this.state;
        winUsersMap.set(e.target.value, false)
        this.setState({
            winUsersMap
        })
    }
    //更改中奖序号的相关事件
    inputRandomChange(index, type, e) {
        let value = Number(e.target.value);
        const { emptyRandom } = this.state;
        if (!/^[0-9]+$/.test(e.target.value)) {
            e.target.value = e.target.value.slice(0, e.target.value.length - 1)
        }
        if (type == 'random' && index == emptyRandom - 1)
            this.setState({ emptyRandom: '' })
    }
    focusSpecialLuckyNum(index, e) {
        const { newPrizeItem } = this.state;
        let count = 0;
        newPrizeItem.specialLuckyList.map((item, key) => {
            if (key != index)
                count += Number(item.num)
        })
        this.setState({ remainRandom: Number(newPrizeItem.hbNum) - Number(newPrizeItem.defaultNum) - count })
    }
    inputRandomBlur(index, e) {
        const { newPrizeItem, RandomMap, hbNum, defaultWinnum } = this.state;
        let value = Number(e.target.value);
        if (RandomMap.get(value) || value == 0) {
            message.error(RandomMap.get(value) ? '该序号已使用' : '中奖序号不可为空');
            e.target.value = newPrizeItem.winNos[index];
            RandomMap.set(newPrizeItem.winNos[index], true);
        } else if (value > (hbNum - defaultWinnum)) {
            message.error('该序号不在指定的中奖范围内');
            e.target.value = newPrizeItem.winNos[index];
            RandomMap.set(newPrizeItem.winNos[index], true);
        } else {
            newPrizeItem.winNos[index] = value;
            RandomMap.set(value, true);
        }
        this.setState({
            newPrizeItem,
            RandomMap
        })
    }
    focusRandom(e) {
        const { RandomMap } = this.state;
        RandomMap.set(Number(e.target.value), false)
        this.setState({
            RandomMap
        })
    }
    inputAssignBlur(index, valueIndex, e) {
        const { newPrizeItem, RandomMap, winNosList, hbNum, defaultWinnum } = this.state;
        let value = Number(e.target.value);
        if (RandomMap.get(value) || value == 0) {
            message.error(RandomMap.get(value) ? '该中奖序号已经存在' : '中奖序号不可为空');
            e.target.value = winNosList[index][valueIndex];
            RandomMap.set(winNosList[index][valueIndex], true);
        } else if ((newPrizeItem.specialLuckyList[index].max && value > newPrizeItem.specialLuckyList[index].max) || (value > hbNum - defaultWinnum) || (newPrizeItem.specialLuckyList[index].min && value < newPrizeItem.specialLuckyList[index].min) || value < 1) {
            message.error('该序号不在指定的中奖范围内');
            e.target.value = winNosList[index][valueIndex];
            RandomMap.set(winNosList[index][valueIndex], true);
        } else {
            winNosList[index][valueIndex] = value;
            RandomMap.set(value, true);
        }
        this.setState({
            newPrizeItem,
            RandomMap
        })
    }
    checkMoneyMax(e) {
        let { newPrizeItem } = this.state;
        if (newPrizeItem.luckyMax && newPrizeItem.luckyMin && Number(newPrizeItem.luckyMax) < Number(newPrizeItem.luckyMin)) {
            message.error('金额范围有误')
        }
    }
    tapClose(index) {
        const { showList } = this.state;
        showList[index] = !showList[index];
        this.setState({
            showList
        })
    }
    showRemainHb(value, type, e) {
        let { newPrizeItem, remainPrize, remainDefault, remainRandom } = this.state;
        switch (type) {
            case 'remainPrize':
                if (Number(newPrizeItem.hbNum) > Number(remainPrize)) {
                    newPrizeItem.hbNum = '';
                    message.error('不得多于剩余奖品数')
                }
                value = value == 'true' ? true : false;
                newPrizeItem.specialLuckyList = [];
                if (newPrizeItem.defaultNum) {
                    remainRandom = Number(newPrizeItem.hbNum) - Number(newPrizeItem.defaultNum)
                } else {
                    remainRandom = Number(newPrizeItem.hbNum)
                }
                this.setState({ remainPrizeShow: value, winNosList: [], remainRandom })
                break;
            case 'remainDefault':
                if (Number(newPrizeItem.defaultNum) > Number(newPrizeItem.hbNum)) {
                    newPrizeItem.defaultNum = '';
                    newPrizeItem.winUsers = [];
                    message.error('不得多于奖品设置个数')
                }
                else if (Number(newPrizeItem.defaultNum) > Number(remainDefault)) {
                    newPrizeItem.defaultNum = '';
                    newPrizeItem.winUsers = [];
                    message.error('不得多于剩余内定数')
                } else {
                    newPrizeItem.winUsers = Array.from({ length: Number(newPrizeItem.defaultNum) }, (v, k) => '')
                }
                newPrizeItem.specialLuckyList = [];
                this.setState({ winUsersMap: new Map() })
                value = value == 'true' ? true : false;
                this.setState({ remainDefaultShow: value, winNosList: [], remainRandom })
                break;
        }
        if (newPrizeItem.hbNum && newPrizeItem.defaultNum && newPrizeItem.hbNum > newPrizeItem.defaultNum) {
            this.setState({ remainRandom: Number(newPrizeItem.hbNum) - Number(newPrizeItem.defaultNum) })
        }
        this.setState({ newPrizeItem })

    }
    onModalClose() {
        this.setState({
            modalShow: false
        })
    }
    onModalSuccess() {
        this.setState({
            modalShow: false
        }, () => {
            const { hbList, activityId, yidunHongbao, hbNum, defaultWinnum } = this.state;
            console.log(activityId)
            let data = {
                activityId: activityId,
                hbList: JSON.stringify(hbList),
                yidunHongbao: yidunHongbao,
                hbNum: hbNum,
                defaultWinnum: defaultWinnum
            }
            this.publishRule(data);
        })
    }
    deletePrize(item, index) {//删除奖项
        let { hbList, remainPrize, remainDefault, RandomMap, showList } = this.state;
        hbList.splice(index, 1);
        showList.splice(index, 1);
        //更改剩余奖品数
        if (item.hbNum) {
            remainPrize += Number(item.hbNum)
        }
        //更改剩余内定数
        if (item.defaultNum) {
            remainDefault += Number(item.defaultNum)
        }
        //更改randomMap
        item.winNos.map((item, index) => {
            RandomMap.set(Number(item), false);
        })
        console.log(RandomMap)
        this.setState({
            hbList, remainPrize, remainDefault, RandomMap, showList
        })
    }
    goBack() {
        this.props.history.go(-2)
    }
    render() {
        const {
            hbNum,
            defaultWinnum,
            yidunHongbao,
            hbList,
            modalShow,
            prizeLevelList,
            newPrizeItem,
            showList,
            remainPrize,
            remainPrizeShow,
            remainDefault,
            remainDefaultShow,
            hasClickedSavePrize,
            emptyWinUser,
            remainRandom,
            checkPrizeList,
            winNosList,
            ruleType
        } = this.state;
        return (
            <DocumentTitle title="添加规则">
                <ConfigProvider locale={zhCN}>
                    <div className="PublishRulesPane">
                        <Button onClick={this.goBack.bind(this)}>返回上一页</Button>
                        <div className="inputItem">
                            <span className="inputTitle">红包总个数</span>
                            <Input placeholder="红包墙的红包数量" disabled={ruleType == 0 ? false : true} onBlur={this.blurZeroToNull.bind(this, 'hbNum')} onFocus={this.storeValue.bind(this, 'hbNum')} className="inputBlock" value={hbNum} onChange={this.inputItemChange.bind(this, 'hbNum')}></Input>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">内定总个数</span>
                            <Input placeholder="大奖可内定中奖用户id数" disabled={ruleType == 0 ? false : true} onBlur={this.blurZeroToNull.bind(this, 'defaultNum')} onFocus={this.storeValue.bind(this, 'defaultWinnum')} className="inputBlock" value={defaultWinnum} onChange={this.inputItemChange.bind(this, 'defaultNum')}></Input>
                        </div>
                        <div className="inputItem">
                            <span className="inputTitle">蚁盾高分用户</span>
                            <Select className="selectBlock" value={yidunHongbao} disabled={ruleType == 0 ? false : true} style={{ width: 200 }} onChange={this.yidunHongbaoChange.bind(this)}>
                                <Option value="0">不限制</Option>
                                <Option value="1">幸运现金奖</Option>
                                <Option value="2">幸运实物奖</Option>
                                <Option value="3">补空奖项</Option>
                            </Select>
                        </div>
                        {
                            hbList.map((item, index) => {
                                return <div key={'prizeItemPane' + index} className="prizeItemPane">
                                    <span className="prizeName" onClick={this.tapClose.bind(this, index)}>
                                        <span>奖项名称：{item.hbName}</span>
                                        <span>
                                            奖项类型：{item.hbType == 0 ? '现金奖' : '实物奖'}
                                        </span>
                                        {
                                            ruleType == 0 &&
                                            <Popconfirm placement="top" title='确定要删除此奖项么' onConfirm={this.deletePrize.bind(this, item, index)} okText="确认" cancelText="取消">
                                                <Button type='danger'>删除</Button>
                                            </Popconfirm>
                                        }
                                    </span>
                                    {
                                        showList[index] &&
                                        <div className="prizeDisplayPane">
                                            {
                                                item.level != 100 &&
                                                <div className="cashPane">
                                                    <div className="normalPrizePane">
                                                        {
                                                            item.level != 5 && item.level != 100 && item.hbType == 0 &&//特等奖到十等奖 现金奖
                                                            <div className="inputItem">
                                                                <span className="inputTitle">单个金额</span>
                                                                <div className="inputBlock">{item.singleMoney}</div>
                                                            </div>
                                                        }
                                                        {
                                                            item.level == 5 && item.hbType == 0 &&//幸运奖 现金奖
                                                            <div className="inputItem">
                                                                <span className="inputTitle">总金额</span>
                                                                <div className="inputBlock">{item.totalAmount / 100}</div>
                                                            </div>
                                                        }
                                                        {
                                                            item.level != 100 && item.hbType == 1 &&// 实物奖项（包含幸运奖和一到十等奖）
                                                            <div>
                                                                <div className="inputItem">
                                                                    <span className="inputTitle">实物类型</span>
                                                                    <Radio.Group value={item.subType} disabled>
                                                                        <Radio value={0}>普通的实物</Radio>
                                                                        <Radio value={1}>红包卡实物</Radio>
                                                                        <Radio value={2}>奖券</Radio>
                                                                    </Radio.Group>
                                                                </div>
                                                                <div className="inputItem">
                                                                    <span className="inputTitle">奖项内容</span>
                                                                    <div className="inputBlock">{item.materialName}</div>
                                                                </div>
                                                                <div className="inputItem">
                                                                    <span className="inputTitle">图片</span>
                                                                    <div className="picBlock" style={{ 'backgroundImage': 'url(' + item.materialImage.picture + ')' }}></div>
                                                                </div>
                                                                {
                                                                    item.subType == 1 &&
                                                                    <div className="inputItem">
                                                                        <span className="inputTitle">单个张数</span>
                                                                        <div className="inputBlock">{item.hbCardNum}</div>
                                                                    </div>
                                                                }
                                                                {
                                                                    item.subType == 2 &&
                                                                    <div className="inputItem">
                                                                        <span className="inputTitle">奖券Id</span>
                                                                        <div className="inputBlock">{item.subRelation_id}</div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        }
                                                        <div className="inputItem">
                                                            <span className="inputTitle">个数</span>
                                                            <div className="inputBlock">{item.hbNum}</div>
                                                        </div>
                                                        {
                                                            item.level == 5 && item.hbType == 0 &&//幸运奖 现金奖
                                                            <div className="inputItem">
                                                                <span className="inputTitle">金额分配</span>
                                                                <Radio.Group value={item.mode} disabled>
                                                                    <Radio value={0}>金额随机</Radio>
                                                                    <Radio value={1}>平均分配</Radio>
                                                                </Radio.Group>
                                                            </div>
                                                        }
                                                        {
                                                            item.level != 5 &&
                                                            <div>
                                                                <div className="inputItem">
                                                                    <span className="inputTitle">内定数量</span>
                                                                    <div className="inputBlock">{item.defaultNum}</div>
                                                                </div>
                                                                <div className="inputItem align-flex-start">
                                                                    <span className="inputTitle">内定用户ID</span>
                                                                    <div className="winUserPane displayInput">
                                                                        {
                                                                            item.winUsers.map((value, index) => {
                                                                                return <Input key={'winUser' + value + '_' + index} className="winUser" value={value} disabled></Input>
                                                                            })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        }
                                                        <div className="inputItem align-flex-start">
                                                            <span className="inputTitle">中奖序号</span>
                                                            <div className="winUserPane">
                                                                {
                                                                    item.winNos.map((item, index) => {
                                                                        return <Input value={item} key={'winNos' + item + '_' + index} className="winUser" disabled></Input>
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                item.level == 100 &&
                                                <div className="cashPane">
                                                    <div className="inputItem">
                                                        <span className="inputTitle">发放方式</span>
                                                        <Radio.Group value={item.futureCashMode} disabled>
                                                            <Radio value={1}>随机</Radio>
                                                            <Radio value={2}>固定</Radio>
                                                        </Radio.Group>
                                                    </div>
                                                    <div className="inputItem">
                                                        <span className="inputTitle">金额</span>
                                                        <div className="inputBlock">
                                                            {
                                                                item.futureCashMode == 1 &&
                                                                <div>{item.luckyMin / 100}-{item.luckyMax / 100}</div>
                                                            }
                                                            {
                                                                item.futureCashMode == 2 &&
                                                                <div>{item.luckyMin / 100}</div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            })
                        }
                        {
                            ruleType == 0 &&
                            <div className="addPrizePane" >
                                {
                                    newPrizeItem.level != 100 &&
                                    <div className="inputItem">
                                        <span className="inputTitle">奖品类型</span>
                                        <Select className="selectBlock" value={newPrizeItem.hbType} style={{ width: 200 }} onChange={this.selectChange.bind(this, 'prizeType')}>
                                            <Option value="0">现金奖</Option>
                                            <Option value="1">实物奖</Option>
                                        </Select>
                                    </div>
                                }
                                <div className="inputItem">
                                    <span className="inputTitle">奖品等级</span>
                                    <Select className="selectBlock" value={'' + newPrizeItem.level} style={{ width: 200 }} onChange={this.selectChange.bind(this, 'prizeLevel')}>
                                        {
                                            prizeLevelList.map((item, index) => {
                                                return <Option key={'prizeLevel' + index} value={item.id}>{item.type}</Option>
                                            })
                                        }
                                    </Select>
                                </div>
                                <div className="inputItem">
                                    <span className="inputTitle">奖项名称</span>
                                    <Input className="inputBlock" value={newPrizeItem.hbName} onChange={this.inputItemChange.bind(this, 'prizeName')}></Input>
                                </div>
                                {
                                    newPrizeItem.level != 5 && newPrizeItem.level != 100 && newPrizeItem.hbType == 0 &&
                                    <div className="inputItem">
                                        <span className="inputTitle">单个金额</span>
                                        <Input className="inputBlock" value={newPrizeItem.singleMoney} onChange={this.inputItemChange.bind(this, 'singleMoney')}></Input>
                                        {
                                            hasClickedSavePrize && !newPrizeItem.singleMoney && <div className="formItemError">此项不能为空</div>
                                        }
                                    </div>
                                }
                                {
                                    newPrizeItem.level == 5 && newPrizeItem.hbType == 0 &&
                                    <div className="inputItem">
                                        <span className="inputTitle">总金额</span>
                                        <Input className="inputBlock" value={newPrizeItem.totalAmount} onChange={this.inputItemChange.bind(this, 'totalMoney')}></Input>
                                        {
                                            hasClickedSavePrize && !newPrizeItem.totalAmount && <div className="formItemError">此项不能为空</div>
                                        }
                                    </div>
                                }
                                {
                                    newPrizeItem.hbType == 1 && newPrizeItem.level != 100 &&
                                    <div>
                                        <div className="inputItem">
                                            <span className="inputTitle">实物类型</span>
                                            <Radio.Group onChange={this.radioChange.bind(this, 'realPrizeType')} value={newPrizeItem.subType}>
                                                <Radio value={0}>普通的实物</Radio>
                                                <Radio value={1}>红包卡实物</Radio>
                                                <Radio value={2}>奖券</Radio>
                                            </Radio.Group>
                                        </div>
                                        <div className="inputItem">
                                            <span className="inputTitle">奖项内容</span>
                                            <Input className="inputBlock" value={newPrizeItem.materialName} onChange={this.inputItemChange.bind(this, 'materialName')}></Input>
                                            {
                                                hasClickedSavePrize && !newPrizeItem.materialName && <div className="formItemError">此项不能为空</div>
                                            }
                                        </div>
                                        <div className="inputItem">
                                            <span className="inputTitle">图片</span>
                                            <div id="chooseRealItemImage" className="chooseActivityPic" style={{ "backgroundImage": newPrizeItem.materialImage ? 'url(' + newPrizeItem.materialImage + ')' : 'url(http://s1.im-dangdang.com/dev/20200420/H2EnpAExQr.png)' }}></div>
                                            {
                                                hasClickedSavePrize && !newPrizeItem.materialImage && <div className="formItemError">此项不能为空</div>
                                            }
                                        </div>
                                        {
                                            newPrizeItem.subType == 1 &&
                                            <div className="inputItem">
                                                <span className="inputTitle">单个张数</span>
                                                <Input className="inputBlock" value={newPrizeItem.hbCardNum} onChange={this.inputItemChange.bind(this, 'hbCardNum')}></Input>
                                                {
                                                    hasClickedSavePrize && !newPrizeItem.hbCardNum && <div className="formItemError">此项不能为空</div>
                                                }
                                            </div>
                                        }
                                        {
                                            newPrizeItem.subType == 2 &&
                                            <div className="inputItem">
                                                <span className="inputTitle">奖券Id</span>
                                                <Input className="inputBlock" value={newPrizeItem.subRelation_id} onChange={this.inputItemChange.bind(this, 'subRelation_id')}></Input>
                                                {
                                                    hasClickedSavePrize && !newPrizeItem.subRelation_id && <div className="formItemError">此项不能为空</div>
                                                }
                                            </div>
                                        }
                                    </div>
                                }
                                {
                                    newPrizeItem.level != 100 &&
                                    <div>
                                        <div className="inputItem">
                                            <span className="inputTitle">个数</span>
                                            <Input className="inputBlock" onBlur={this.showRemainHb.bind(this, 'false', 'remainPrize')} onFocus={this.showRemainHb.bind(this, 'true', 'remainPrize')} value={newPrizeItem.hbNum} onChange={this.inputItemChange.bind(this, 'prizeHbNum')}></Input>
                                            {remainPrizeShow && <span className="tipInfo">剩余奖品数  {remainPrize}</span>}
                                            {
                                                hasClickedSavePrize && !newPrizeItem.hbNum && <div className="formItemError">此项不能为空</div>
                                            }
                                        </div>
                                        {
                                            newPrizeItem.level != 5 &&
                                            <div>
                                                <div className="inputItem">
                                                    <span className="inputTitle">内定数量</span>
                                                    <Input className="inputBlock" onBlur={this.showRemainHb.bind(this, 'false', 'remainDefault')} onFocus={this.showRemainHb.bind(this, 'true', 'remainDefault')} value={newPrizeItem.defaultNum} onChange={this.inputItemChange.bind(this, 'prizeDefaultNum')}></Input>
                                                    {remainDefaultShow && <span className="tipInfo">剩余内定数  {remainDefault}</span>}
                                                    {
                                                        hasClickedSavePrize && !newPrizeItem.defaultNum && <div className="formItemError">此项不能为空</div>
                                                    }
                                                </div>
                                                <div className="inputItem flex-dir-col align-flex-start">
                                                    <div className="topDefault align-flex-start">
                                                        <span className="inputTitle">内定用户ID</span>
                                                        <div className="winUserPane">
                                                            {
                                                                newPrizeItem.winUsers.map((item, index) => {
                                                                    return <input onPaste={(e) => e.preventDefault()} key={'winUser' + item + '_' + index} defaultValue={item} className="winUser" onChange={this.inputDefaultNumChange.bind(this, index)} onBlur={this.inputDefaultNumBlur.bind(this, index)} onFocus={this.focusDefaultNum.bind(this)}></input>
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                    {
                                                        hasClickedSavePrize && emptyWinUser && <div className="formItemError winuser-margin">内定用户Id存在空项 第{emptyWinUser}个</div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                                {
                                    newPrizeItem.level == 5 && newPrizeItem.hbType == 0 &&
                                    <div className="inputItem">
                                        <span className="inputTitle">金额分配</span>
                                        <Radio.Group value={newPrizeItem.mode} onChange={this.radioChange.bind(this, 'luckyType')}>
                                            <Radio value={0}>金额随机</Radio>
                                            <Radio value={1}>平均分配</Radio>
                                        </Radio.Group>
                                    </div>
                                }
                                {
                                    newPrizeItem.level != 100 &&
                                    <div>
                                        <div className="inputItem">
                                            <span className="inputTitle">非内定奖项的发放方式</span>
                                            <Radio.Group value={newPrizeItem.luckNumType}>
                                                <Radio onClick={this.randomWin.bind(this)} value={1}>指定序号</Radio>
                                                <Radio onClick={this.randomWin.bind(this)} value={2}>随机发放</Radio>
                                            </Radio.Group>
                                            {
                                                newPrizeItem.luckNumType == 1 && newPrizeItem.specialLuckyList.length == 0 && <Button onClick={this.addSpecialLuckyList.bind(this)}
                                                    disabled={((newPrizeItem.level != 5 && newPrizeItem.defaultNum) || newPrizeItem.level == 5) && newPrizeItem.hbNum && newPrizeItem.specialLuckyList.length == winNosList.length && remainRandom > 0 ? false : true}>
                                                    添加
                                            </Button>
                                            }
                                        </div>
                                        {
                                            newPrizeItem.luckNumType == 1 &&
                                            <div>
                                                {
                                                    newPrizeItem.specialLuckyList.map((item, index) => {
                                                        return <div className="specialGroupInfo" key={'specialGroupInfo' + index}>
                                                            <div className="inputItem">
                                                                <span className="inputTitle">第{index + 1}组数量</span>
                                                                <input className="inputBlock" disabled={winNosList[index] ? true : false} id={"specialLuckNum" + index} onFocus={this.focusSpecialLuckyNum.bind(this, index)} onBlur={this.inputSpecialLuckyNum.bind(this, 'specialLuckyNum', index)} onChange={this.changeSpecialLuckyNum.bind(this, 'specialLuckyNum', index)} onPaste={(e) => e.preventDefault()} defaultValue={item.num}></input>
                                                                {index == newPrizeItem.specialLuckyList.length - 1 && <span className="tipInfo">剩余可分配数量  {remainRandom}</span>}
                                                                <div className="specialButton">
                                                                    <Button onClick={this.specialLuckyListClick.bind(this, 'random', index)} disabled={!item.num}>随机</Button>
                                                                    {
                                                                        newPrizeItem.luckNumType == 1 && newPrizeItem.specialLuckyList.length - 1 == index &&
                                                                        <Button onClick={this.addSpecialLuckyList.bind(this)}
                                                                            disabled={((newPrizeItem.level != 5 && newPrizeItem.defaultNum) || newPrizeItem.level == 5) && newPrizeItem.hbNum && newPrizeItem.specialLuckyList.length == winNosList.length && remainRandom > 0 ? false : true}>
                                                                            添加
                                                                        </Button>
                                                                    }
                                                                    <Popconfirm placement="top" title='确定删除吗?' onConfirm={this.specialLuckyListClick.bind(this, 'delete', index)} okText="确认" cancelText="取消">
                                                                        <Button type="danger">删除</Button>
                                                                    </Popconfirm>
                                                                </div>
                                                            </div>
                                                            <div className="inputItem">
                                                                <span className="inputTitle">中奖范围</span>
                                                                <input className="inputBlock" disabled={winNosList[index] ? true : false} onChange={this.changeSpecialLuckyNum.bind(this, 'specialLuckyRangeMin', index)} id={"specialLuckMin" + index} defaultValue={item.min} onBlur={this.inputSpecialLuckyNum.bind(this, 'specialLuckyRangeMin', index)} onPaste={(e) => e.preventDefault()}></input>
                                                                -
                                                            <input className="inputBlock" disabled={winNosList[index] ? true : false} onChange={this.changeSpecialLuckyNum.bind(this, 'specialLuckyRangeMax', index)} id={"specialLuckMax" + index} defaultValue={item.max} onBlur={this.inputSpecialLuckyNum.bind(this, 'specialLuckyRangeMax', index)} onPaste={(e) => e.preventDefault()}></input>
                                                            </div>
                                                            <div className="inputItem align-flex-start">
                                                                <span className="inputTitle">中奖序号</span>
                                                                <div className="winUserPane">
                                                                    {
                                                                        winNosList.length > index && winNosList[index].map((value, valueIndex) => {
                                                                            return <input onPaste={(e) => e.preventDefault()} key={'winNos' + value + '_' + valueIndex} defaultValue={value} className="winUser" onChange={this.inputRandomChange.bind(this, valueIndex, 'assign')} onBlur={this.inputAssignBlur.bind(this, index, valueIndex)} onFocus={this.focusRandom.bind(this)} ></input>
                                                                        })
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                        }
                                        {
                                            newPrizeItem.luckNumType != 1 &&
                                            <div className="inputItem align-flex-start">
                                                <span className="inputTitle">中奖序号</span>
                                                <div className="winUserPane">
                                                    {
                                                        newPrizeItem.winNos.map((item, index) => {
                                                            return <input onPaste={(e) => e.preventDefault()} key={'winNos' + item + '_' + index} defaultValue={item} className="winUser" onChange={this.inputRandomChange.bind(this, index, 'random')} onBlur={this.inputRandomBlur.bind(this, index)} onFocus={this.focusRandom.bind(this)} ></input>
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                                {
                                    newPrizeItem.level == 100 &&
                                    <div>
                                        <div className="inputItem">
                                            <span className="inputTitle">发放方式</span>
                                            <Radio.Group onChange={this.radioChange.bind(this, 'futureCashMode')} value={newPrizeItem.futureCashMode}>
                                                <Radio value={1}>随机</Radio>
                                                <Radio value={2}>固定</Radio>
                                            </Radio.Group>
                                        </div>
                                        <div className="inputItem">
                                            <span className="inputTitle">金额</span>
                                            <div className="inputBlock">
                                                {
                                                    newPrizeItem.futureCashMode == 1 &&
                                                    <div className="rangePane">
                                                        <Input value={newPrizeItem.luckyMin ? newPrizeItem.luckyMin / 100 : ''} onChange={this.inputItemChange.bind(this, 'luckyMin')}></Input>-<Input value={newPrizeItem.luckyMax ? newPrizeItem.luckyMax / 100 : ''} onBlur={this.checkMoneyMax.bind(this)} onChange={this.inputItemChange.bind(this, 'luckyMax')}></Input>
                                                    </div>
                                                }
                                                {
                                                    newPrizeItem.futureCashMode == 2 &&
                                                    <Input value={newPrizeItem.luckyMin ? newPrizeItem.luckyMin / 100 : ''} onChange={this.inputItemChange.bind(this, 'luckyAll')}></Input>
                                                }
                                            </div>
                                            {
                                                hasClickedSavePrize && (!newPrizeItem.luckyMin || !newPrizeItem.luckyMax) && <div className="formItemError">此项不能为空</div>
                                            }
                                        </div>
                                        <div className="futureInfo">
                                            注意：个数不在奖品配置范围，该奖可用于补充空缺：<br></br>
                                            1、配置奖品总数&#60;红包总数时<br></br>
                                            2、内定的大奖无人领取时<br></br>
                                            3、蚁盾高分用户（可视为另一种形式的内定）太多时<br></br>
                                        </div>
                                    </div>
                                }
                                {
                                    ruleType == 0 &&
                                    <Button onClick={this.addNewPrize.bind(this)}>
                                        添加奖品
                                    </Button>
                                }
                            </div>
                        }
                        <PrizePreview onModalSuccess={this.onModalSuccess.bind(this)} onModalClose={this.onModalClose.bind(this)} show={modalShow} data={checkPrizeList}></PrizePreview>
                        {
                            ruleType == 0 &&
                            <Button onClick={this.publishRules.bind(this)} disabled={hbList.length == 0 ? true : false}>
                                发布规则
                            </Button>
                        }
                    </div>
                </ConfigProvider>
            </DocumentTitle>
        )
    }
}
export default PublishActivity;
